@import "../../../../shared/scss";

:host {
  display: block;
  visibility: visible;
  position: static;
  z-index: $phn-z-index-header;

  .header {
    min-block-size: $phn-header-height-base;

    @include pds-media-query-min("xs") {
      min-block-size: $phn-header-height-xs;
    }

    @include pds-media-query-min("s") {
      min-block-size: $phn-header-height-s;
    }

    @include pds-media-query-min("m") {
      min-block-size: $phn-header-height-m;
    }

    @include pds-media-query-min("l") {
      min-block-size: $phn-header-height-l;
    }
  }

  .limited-width {
    @include pds-media-query-min("xxl") {
      max-inline-size: p-px-to-rem(2560px);
      margin-block: 0;
      margin-inline: auto;
    }
  }
}
